/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sales_Headings_ActiveInputs */

const id_sales_headings_active = /** @type {(inputs: Sales_Headings_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diskon Aktif`)
};

const ms_sales_headings_active = /** @type {(inputs: Sales_Headings_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jualan Aktif`)
};

const da_sales_headings_active = /** @type {(inputs: Sales_Headings_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktive Udsalg`)
};

const de_sales_headings_active = /** @type {(inputs: Sales_Headings_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktive Angebote`)
};

const en_us2_sales_headings_active = /** @type {(inputs: Sales_Headings_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active Sales`)
};

const es_es2_sales_headings_active = /** @type {(inputs: Sales_Headings_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rebajas activas`)
};

const es_mx2_sales_headings_active = /** @type {(inputs: Sales_Headings_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Promociones activas`)
};

const fil_sales_headings_active = /** @type {(inputs: Sales_Headings_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Aktibong Sale`)
};

const fr_sales_headings_active = /** @type {(inputs: Sales_Headings_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Promotions actives`)
};

const it_sales_headings_active = /** @type {(inputs: Sales_Headings_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sconti attivi`)
};

const hu_sales_headings_active = /** @type {(inputs: Sales_Headings_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktív akciók`)
};

const nl_sales_headings_active = /** @type {(inputs: Sales_Headings_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actieve aanbiedingen`)
};

const no_sales_headings_active = /** @type {(inputs: Sales_Headings_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktive salg`)
};

const pl_sales_headings_active = /** @type {(inputs: Sales_Headings_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktywne promocje`)
};

const pt_br2_sales_headings_active = /** @type {(inputs: Sales_Headings_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Promoções ativas`)
};

const pt_sales_headings_active = /** @type {(inputs: Sales_Headings_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Promoções ativas`)
};

const ro_sales_headings_active = /** @type {(inputs: Sales_Headings_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reduceri active`)
};

const fi_sales_headings_active = /** @type {(inputs: Sales_Headings_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktiiviset alennukset`)
};

const sv_sales_headings_active = /** @type {(inputs: Sales_Headings_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktiva reor`)
};

const vi_sales_headings_active = /** @type {(inputs: Sales_Headings_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giảm giá đang hoạt động`)
};

const tr_sales_headings_active = /** @type {(inputs: Sales_Headings_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktif İndirimler`)
};

const cs_sales_headings_active = /** @type {(inputs: Sales_Headings_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktivní slevy`)
};

const bg_sales_headings_active = /** @type {(inputs: Sales_Headings_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Активни промоции`)
};

const ru_sales_headings_active = /** @type {(inputs: Sales_Headings_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Активные скидки`)
};

const uk_sales_headings_active = /** @type {(inputs: Sales_Headings_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Активні розпродажі`)
};

const ar_sales_headings_active = /** @type {(inputs: Sales_Headings_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التخفيضات النشطة`)
};

const hi_sales_headings_active = /** @type {(inputs: Sales_Headings_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सक्रिय सेल`)
};

const th_sales_headings_active = /** @type {(inputs: Sales_Headings_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ลดราคาที่กำลังใช้งาน`)
};

const ja_sales_headings_active = /** @type {(inputs: Sales_Headings_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アクティブなセール`)
};

const zh_cn2_sales_headings_active = /** @type {(inputs: Sales_Headings_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在进行的促销`)
};

const zh_hant1_sales_headings_active = /** @type {(inputs: Sales_Headings_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在進行的促銷`)
};

const ko_sales_headings_active = /** @type {(inputs: Sales_Headings_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`진행 중인 할인`)
};

/**
* | output |
* | --- |
* | "Active Sales" |
*
* @param {Sales_Headings_ActiveInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sales_headings_active = /** @type {((inputs?: Sales_Headings_ActiveInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sales_Headings_ActiveInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sales_headings_active(inputs)
	if (locale === "ms") return ms_sales_headings_active(inputs)
	if (locale === "da") return da_sales_headings_active(inputs)
	if (locale === "de") return de_sales_headings_active(inputs)
	if (locale === "en-US") return en_us2_sales_headings_active(inputs)
	if (locale === "es-ES") return es_es2_sales_headings_active(inputs)
	if (locale === "es-MX") return es_mx2_sales_headings_active(inputs)
	if (locale === "fil") return fil_sales_headings_active(inputs)
	if (locale === "fr") return fr_sales_headings_active(inputs)
	if (locale === "it") return it_sales_headings_active(inputs)
	if (locale === "hu") return hu_sales_headings_active(inputs)
	if (locale === "nl") return nl_sales_headings_active(inputs)
	if (locale === "no") return no_sales_headings_active(inputs)
	if (locale === "pl") return pl_sales_headings_active(inputs)
	if (locale === "pt-BR") return pt_br2_sales_headings_active(inputs)
	if (locale === "pt") return pt_sales_headings_active(inputs)
	if (locale === "ro") return ro_sales_headings_active(inputs)
	if (locale === "fi") return fi_sales_headings_active(inputs)
	if (locale === "sv") return sv_sales_headings_active(inputs)
	if (locale === "vi") return vi_sales_headings_active(inputs)
	if (locale === "tr") return tr_sales_headings_active(inputs)
	if (locale === "cs") return cs_sales_headings_active(inputs)
	if (locale === "bg") return bg_sales_headings_active(inputs)
	if (locale === "ru") return ru_sales_headings_active(inputs)
	if (locale === "uk") return uk_sales_headings_active(inputs)
	if (locale === "ar") return ar_sales_headings_active(inputs)
	if (locale === "hi") return hi_sales_headings_active(inputs)
	if (locale === "th") return th_sales_headings_active(inputs)
	if (locale === "ja") return ja_sales_headings_active(inputs)
	if (locale === "zh-CN") return zh_cn2_sales_headings_active(inputs)
	if (locale === "zh-Hant") return zh_hant1_sales_headings_active(inputs)
	return ko_sales_headings_active(inputs)
});
export { sales_headings_active as "sales.headings.active" }